import { Component, OnInit, Inject,OnDestroy,ViewEncapsulation,ViewChild} from '@angular/core';
import { Validators, FormGroup, FormControl} from '@angular/forms';
import { MAT_DIALOG_DATA} from '@angular/material';
import { MatDialogRef,MatSelect,MatOption, MatDialog} from '@angular/material';
import { MediaChange, MediaObserver } from '@angular/flex-layout';
import { Subscription, Subject } from 'rxjs';
import { enumAlertType, enumNotifyTypeItem, enumNotifyTypeText,appsettings} from '../../../app-settings';
import { notificationService } from '../notification.service';
import { NotificationForCreationResponse,NotifyType,getRoleIndividualList,selectedEscalations, UpdateNotification, notifyTypeItem, getNotificationLevels, checkAlertItem} from '../notification';
import { RollbarService } from '../../../rollbar';
import * as Rollbar from 'rollbar';
import { SessionCheck,generateAlertMessage,AuthFailedMessage } from '../../../app-general';
import {Router} from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { ConfirmMessageComponent } from '../../../confirm-message/confirm-message.component';
import { ApiService } from '../../../api.service';

@Component({
  selector: 'app-edit-notification',
  templateUrl: './edit-notification.component.html',
  providers: [ notificationService],
  encapsulation: ViewEncapsulation.None,
  styleUrls: ['./edit-notification.component.scss']
})
export class EditNotificationComponent implements OnInit,OnDestroy {
  watcher: Subscription;
  columns: number = 8;
  notifytype="";
  notifytypeItem;
  CampusId=0;
  AlarmId;
  AlarmSubTypeId=0;
  AlertId;
  Escalationlevel;
  ErrorMsg: string;
  SiteId = "1";
  public notificationeditCreationForm : FormGroup; 
  RoleIndividualList:getRoleIndividualList[];
  NotifyType:NotifyType[]=[{Notifytype:'Individual',NotifytypeId:1},{Notifytype:'Role (Global)',NotifytypeId:0},{Notifytype:'Staff Group',NotifytypeId:2},{Notifytype:'Resident Group',NotifytypeId:3}]; 
  selectedEscalations:selectedEscalations[];
  selectedRoleId;  
  Notifytype;
  RoleId = "0";
  individualId = "0";  
  GroupId="0";
  campusName;
  eventName; 
  TimetoEscalate;
  GroupType;
  updateNotifyflag : boolean = true;
  selectedBuildingName;
  selectedFloorName;
  BuildingId=0;
  FloorId=0;
  SubZoneId = 0;
  selectedSubZoneName;
  chkEscalateyesvalue:boolean = true;
  chkEscalatenovalue:boolean = false;
  
  checkEscalate:boolean = false;
  checkRepeatLevel:boolean = false;
  
  
  Escalatevalue;
  RepeatLevelvalue;
  TimeEscalatevalue;
  RepeatCyclevalue;
  RepeatNumbervalue;
  AlarmSubType_Name;
  AlaramType;
  public EnumAlertType = enumAlertType;
  showNotifyWarningImage = false;
  private _onDestroy: Subject<void> = new Subject<void>();
  EscalateInfoTooltip = "When Repeat Level Disabled, the Time to Escalate value can be manually entered once Escalate is enabled.\n\n When Repeat Level Enabled, " +
                        "Time to Escalate is auto-calculated with the value equal to (Repeat Number * Repeat Cycle) + Repeat Cycle, once Escalate is enabled. ";
  NotificationLevelTooltip = "WARNING: Previous notification level(s) has/have not been setup to escalate.For this level to execute,edit previous level.";
  constructor(private router: Router,mediaObserver: MediaObserver,public thisDialogRef: MatDialogRef<EditNotificationComponent>,@Inject(RollbarService) private rollbar: Rollbar, @Inject(MAT_DIALOG_DATA) public data: any,
  private notificationService: notificationService,public dialog: MatDialog,private apiService: ApiService) 
  {             
    this.RoleId = data.RoleId;
    this.individualId = data.StaffId;
    this.Notifytype = data.NotifyType;   
    if (data.CampusId>0)
      this.CampusId = data.CampusId;
    this.AlarmId = data.EventId;
    this.Escalationlevel = data.Level;    
    if (data.AlarmSubTypeId > 0)
      this.AlarmSubTypeId = data.AlarmSubTypeId;
    this.AlertId = data.AlertId;
    this.campusName = data.CampusName;
    this.eventName = data.AlarmNameId;
    this.TimetoEscalate = data.TimetoEscalate;
    this.GroupId = data.GroupId;
    this.GroupType = data.GroupType;
    if (data.BuildingId>0)
      this.BuildingId = data.BuildingId;
    if (data.FloorId>0)
      this.FloorId = data.FloorId;
    if(data.SubZoneId > 0)  
      this.SubZoneId = data.SubZoneId;
    this.Escalatevalue = data.NeedEscalate;
    this.AlarmSubType_Name = data.AlarmSubTypeName;
    if(this.Escalatevalue == 1)
    {     
      this.checkEscalate = true;
      this.TimeEscalatevalue = data.TimetoEscalate;      
    }
    else if(this.Escalatevalue == 0)  
    {
      this.checkEscalate = false;         
    }
    this.RepeatLevelvalue = data.NeedRepeat;
    if(this.RepeatLevelvalue == 1)
    {
      this.checkRepeatLevel = true;
      this.RepeatCyclevalue = data.RepeatCycle;
      this.RepeatNumbervalue = data.RepeatNumber;
    }
    else
    {
      this.checkRepeatLevel = false;
    }
    if(this.BuildingId > 0 || this.BuildingId != null)
        this.selectedBuildingName = data.BuildingName;
      else
        this.selectedBuildingName = "";  
        
      if(this.FloorId > 0 || this.FloorId != null)
        this.selectedFloorName = data.FloorName;
      else
        this.selectedFloorName = ""; 
        
      if(this.SubZoneId > 0 || this.SubZoneId != null)
        this.selectedSubZoneName = data.SubZoneName;
      else
        this.selectedSubZoneName = ""; 
        
      this.watcher = mediaObserver.media$.subscribe((change: MediaChange) => {
        if (change) {
          if (change.mqAlias == 'xs') {
            this.columns = 3;
          } 
          else if (change.mqAlias == 'sm') {
            this.columns = 4;
          }         
          else {
            this.columns = 8;
          }
        }
      });
  }

  ngOnInit() {
       
    var notifyitem : getNotificationLevels=
        {
          siteId:this.SiteId,
          authKey: localStorage.getItem("Authkey"),
          notifyType:this.Notifytype.toString(),
          role:this.RoleId.toString(),
          individual:this.individualId.toString(),
          groupId:this.GroupId.toString()
        }
    this.getNotificationLevels(notifyitem);  
    if(this.Escalationlevel > 1)
      this.getNotifyRepeatEscalateLevel()
      
    this.notificationeditCreationForm = new FormGroup({
        escalation: new FormControl('', []),       
        TimeToEscalate: new FormControl('', [Validators.required,Validators.min(1),Validators.pattern(appsettings.Number_Pattern)]), 
        RepeatLevelNumber: new FormControl('', [Validators.required,Validators.min(1),Validators.pattern(appsettings.Number_Pattern)]), 
        RepeatLevelCycle: new FormControl('', [Validators.required,Validators.min(1),Validators.pattern(appsettings.Number_Pattern)]),     
        notify: new FormControl('', [Validators.required]),        
        NotifyList: new FormControl('', [Validators.required]),       
    });    
    if(!this.checkEscalate || (this.checkEscalate == true && this.checkRepeatLevel == true)) 
      this.notificationeditCreationForm.get('TimeToEscalate').disable();
    if(!this.checkRepeatLevel)
    {
      this.notificationeditCreationForm.get('RepeatLevelNumber').disable();
      this.notificationeditCreationForm.get('RepeatLevelCycle').disable();
    }
  }

  handleInput(event) 
  {
    try
    {
      var n = event.target.value.lastIndexOf(" ");
      var l = event.target.value.length;
      var changedValue = event.target.value;
      if (event.which == 32 && changedValue.trim().length == 0) {
        changedValue = changedValue.trim();
      }
      else if (event.which == 32) {
        if (n + 1 == l) {
          changedValue = changedValue.trim() + " ";
        }
        else {
          changedValue = changedValue.trim();
        }
      }
      Object.keys(this.notificationeditCreationForm.controls).forEach(field => { // {1}
        const control = this.notificationeditCreationForm.get(field); // {2}
        if (field == document.getElementById(event.target.id).getAttribute("formControlName")) {
          control.setValue(changedValue);
          control.markAsTouched({ onlySelf: true });       // {3}
        }
      });
    }
    catch(err) 
    {
      throw new Error('edit-notification.component.ts' + ' - handleInput() - ' + err.message);
    }
  }
 
// On change Notify
@ViewChild('editroleindivi') SelEditRoleIndivi: MatSelect;
  onChangeNotify(event)
  {
    try
    {
      this.selectedRoleId = "";
      this.notifytype = event;
      
      var notifyType = 0;  
      if(this.notifytype == enumNotifyTypeText.Individual)
        notifyType = enumNotifyTypeItem.Individual;
      else if(this.notifytype == enumNotifyTypeText.Role)
        notifyType = enumNotifyTypeItem.Role;
      else if(this.notifytype == enumNotifyTypeText.StaffGroup)
        notifyType = enumNotifyTypeItem.StaffGroup;
      else if(this.notifytype == enumNotifyTypeText.ResidentGroup)
        notifyType = enumNotifyTypeItem.ResidentGroup;

      var notifyType_Item : notifyTypeItem =
      {
        siteId:this.SiteId,
        authKey: localStorage.getItem("Authkey"),
        nType:notifyType
      }
  
        this.getRoleOrIndividualList(notifyType_Item);
        this.SelEditRoleIndivi.options.forEach( (item : MatOption) => {item.deselect()});        
    }
    catch (err) {
      throw new Error('edit-notification.component.ts' + ' - onChangeNotify() - ' + err.message);
    }  
   
  }

// get Role/Invidual Data
getRoleOrIndividualList(notifytype):void 
  {
    try
    {
      this.notificationService.getRoleOrIndividualList(notifytype).pipe(takeUntil(this._onDestroy))
      .subscribe((getRoleIndividualList : any[])=>{
        this.RoleIndividualList = getRoleIndividualList;
        
      });
    }
    catch (err) {
      throw new Error('edit-notification.component.ts' + ' - getRoleOrIndividualList() - ' + err.message);
    }
 
  }

  //Selected escalation details
  getNotificationLevels(notifyitem):void
  {
    try
    {
      
      this.notificationService.getNotificationLevels(notifyitem).pipe(takeUntil(this._onDestroy))
      .subscribe((selectedEscalations : any[])=>{        
        if (selectedEscalations != null && selectedEscalations != undefined)
        {                       
            this.selectedEscalations = selectedEscalations;                          
            this.selectedRoleId =  this.selectedEscalations[0].selectedNotifytype;                 
        }  
      });
    }
    catch (err) {
      throw new Error('edit-notification.component.ts' + ' - getNotificationLevels() - ' + err.message);
    }
   
  }
  
  getNotifyRepeatEscalateLevel()
  {
    try
    {
      var notifyType_Item : any =
      {
        siteId:this.SiteId,
        authKey: localStorage.getItem("Authkey"),
        level:this.Escalationlevel,
        alertId:this.AlertId
      }   
      this.notificationService.getNotifyRepeatEscalateLevels(notifyType_Item).pipe(takeUntil(this._onDestroy))
      .subscribe((EscalationsLevel : any[])=>{        
         console.log(EscalationsLevel)
         if(EscalationsLevel[0].NeedRepeat == 1 && EscalationsLevel[0].NeedEscalate == 0)
          this.showNotifyWarningImage = true;
      });
    }
    catch (err) {
      throw new Error('edit-notification.component.ts' + ' - getNotificationLevels() - ' + err.message);
    }
  }
  // close Notification Dialog
  public onCloseeditNotification = () => {
    this.thisDialogRef.close('Cancel');
    if(!SessionCheck(this.router))
    {
        return;
    }
    
  }

  public hasError = (controlName: string, errorName: string) =>{
    return this.notificationeditCreationForm.controls[controlName].hasError(errorName);
  }

  public createEditNotification = (e_notificationFormValue) => {  
    if(!SessionCheck(this.router))
    {
      this.thisDialogRef.close('Cancel');
        return;
    }  
    
    if (this.notificationeditCreationForm.valid && this.updateNotifyflag) {
      this.updateNotifyflag = false;                     

        if(this.AlarmSubType_Name == "Low Batteries" || this.AlarmSubType_Name == "Lost Communication") // "Maintenance"
        {
          this.notificationeditCreationForm.controls['RepeatLevelNumber'].setValidators([Validators.required,Validators.max(30),Validators.min(1),Validators.pattern(appsettings.Number_Pattern)]);
          this.notificationeditCreationForm.controls["RepeatLevelNumber"].updateValueAndValidity();
          this.updateNotifyflag = true;
          if(!this.notificationeditCreationForm.valid)
              return false; 
              
          this.notificationeditCreationForm.controls['RepeatLevelCycle'].setValidators([Validators.required,Validators.max(72),Validators.min(1),Validators.pattern(appsettings.Number_Pattern)]);
          this.notificationeditCreationForm.controls["RepeatLevelCycle"].updateValueAndValidity();
          this.updateNotifyflag = true;
          if(!this.notificationeditCreationForm.valid)
              return false;                         
        }
        else if(this.AlarmSubType_Name != "Low Batteries" && this.AlarmSubType_Name != "Lost Communication")
        {
          this.notificationeditCreationForm.controls['RepeatLevelNumber'].setValidators([Validators.required,Validators.max(30),Validators.min(1),Validators.pattern(appsettings.Number_Pattern)]);
          this.notificationeditCreationForm.controls["RepeatLevelNumber"].updateValueAndValidity();
          this.updateNotifyflag = true;
          if(!this.notificationeditCreationForm.valid)
              return false;
              
          this.notificationeditCreationForm.controls['RepeatLevelCycle'].setValidators([Validators.required,Validators.max(60),Validators.min(1),Validators.pattern(appsettings.Number_Pattern)]);
          this.notificationeditCreationForm.controls["RepeatLevelCycle"].updateValueAndValidity();
          this.updateNotifyflag = true;
          if(!this.notificationeditCreationForm.valid)
              return false;                         
        }
        
        if(this.AlarmSubType_Name == "Low Batteries" || this.AlarmSubType_Name == "Lost Communication")
        {
          this.notificationeditCreationForm.controls['TimeToEscalate'].setValidators([Validators.required,Validators.max(72),Validators.min(1),Validators.pattern(appsettings.Number_Pattern)]);
          this.notificationeditCreationForm.controls["TimeToEscalate"].updateValueAndValidity();
          this.updateNotifyflag = true;
          if(!this.notificationeditCreationForm.valid)
              return false; 
        }
        else if(this.AlarmSubType_Name != "Low Batteries" && this.AlarmSubType_Name != "Lost Communication")
        {
          this.notificationeditCreationForm.controls['TimeToEscalate'].setValidators([Validators.required,Validators.max(60),Validators.min(1),Validators.pattern(appsettings.Number_Pattern)]);
          this.notificationeditCreationForm.controls["TimeToEscalate"].updateValueAndValidity();
          this.updateNotifyflag = true;
          if(!this.notificationeditCreationForm.valid)
              return false; 
        }
        
       /* if(this.checkEscalate == false && this.checkRepeatLevel == false)
        {
          generateAlertMessage(this.dialog, "Please Select Repeat Level or Escalate");             
          this.updateNotifyflag = true;         
          return;
        }
        else
        {*/
          if(e_notificationFormValue.notify == "Role (Global)")
          {
            if(e_notificationFormValue.TimeToEscalate != this.TimetoEscalate || e_notificationFormValue.NotifyList != this.RoleId)
              this.checkAlertForCampus(e_notificationFormValue);
            else
              this.onEditNotifyClicked(e_notificationFormValue);
          } 
          else if(e_notificationFormValue.notify == "Staff Group" || e_notificationFormValue.notify == "Resident Group" )
          {
            if(e_notificationFormValue.TimeToEscalate != this.TimetoEscalate || e_notificationFormValue.NotifyList != this.GroupId)
             this.checkAlertForCampus(e_notificationFormValue);
          else
            this.onEditNotifyClicked(e_notificationFormValue);
          }
          else
          {          
            if(e_notificationFormValue.TimeToEscalate != this.TimetoEscalate || e_notificationFormValue.NotifyList != this.individualId)
              this.checkAlertForCampus(e_notificationFormValue);
            else
              this.onEditNotifyClicked(e_notificationFormValue);
          }   
       // }
      }
  }

  checkAlertForCampus(e_notificationFormValue)
  {
    this.updateNotifyflag = false;    
    var checkalertItem : checkAlertItem =
     {
       siteId: this.SiteId,
       authKey: localStorage.getItem("Authkey"),
       campusId:this.CampusId,
       eventId: parseInt(this.AlarmId),
       subTypeId:this.AlarmSubTypeId,
       buildId:this.BuildingId,
       floorId:this.FloorId,
       subzoneId:this.SubZoneId
     }
    this.notificationService.checkAlertForCampus(checkalertItem).pipe(takeUntil(this._onDestroy))
    .subscribe((apiresponse : any[])=>{
      if(apiresponse.toString() == "true")
      {        
        this.confirmation(e_notificationFormValue)
      }
      else
      {
        this.onEditNotifyClicked(e_notificationFormValue);
      }
    });

  }
  confirmation(e_notificationFormValue)
  {
    try
    {
      var ConfirmMessageData = {
        ConfirmMessage: "Changes will impact only in future alerts, there will no effects in already raised alerts.<br> Do you want to continue ?"                
      }     
      let dialogRef = this.dialog.open(ConfirmMessageComponent, {
        disableClose: true,
        width: 'auto',
        height: '210px',
        panelClass: 'myapp-no-padding-dialog',
        autoFocus: false,
        data: ConfirmMessageData
      });     
      dialogRef.afterClosed().subscribe(result => {
        if(result == "Yes")
        {              
          this.onEditNotifyClicked(e_notificationFormValue);
        }
        else
        {
            this.updateNotifyflag = true;
            this.thisDialogRef.close('Cancel');
            return;
        }
      });
    }
    catch(err)
    {
        throw new Error('edit-notification.component.ts' + ' - confirmation() - ' + err.message);
    }   
  }
  /////////////////Select All BUilding/////////
  
private onEditNotifyClicked = (e_notificationFormValue) => {
  
        try
        {          
          var Escalatevalue;
          var RepeatLevelvalue;
          var TimetoEscalatevalue;
          var RepeatCyclevalue;
          var RepeatNumbervalue;
          this.updateNotifyflag = false;
          // if(this.chkEscalateyesvalue == true)
          // {
          //   Escalatevalue = 1;
          //   TimetoEscalatevalue = e_notificationFormValue.TimeToEscalate;
          //   RepeatCyclevalue = 0;
          // }
          // else
          // {
          //   Escalatevalue = 0;
          //   TimetoEscalatevalue = 0;
          //   RepeatCyclevalue = e_notificationFormValue.RepeatCycleEscalate;
          // }
          
          if(this.checkEscalate == true)
          {
            Escalatevalue = 1;
            TimetoEscalatevalue = e_notificationFormValue.TimeToEscalate;
          }
          else
            Escalatevalue = 0;
            
          if(this.checkRepeatLevel == true)  
          {
            RepeatLevelvalue = 1;
            RepeatCyclevalue = e_notificationFormValue.RepeatLevelCycle;
            RepeatNumbervalue = e_notificationFormValue.RepeatLevelNumber;
            TimetoEscalatevalue = this.TimeEscalatevalue;
          }
          else
            RepeatLevelvalue = 0;
            
         /* if(this.AlarmSubType_Name == "Low Batteries" || this.AlarmSubType_Name == "Lost Communication")
          {
            if(TimetoEscalatevalue < 1 || TimetoEscalatevalue > 72 && this.checkEscalate == true && this.checkRepeatLevel == false)
            {
              generateAlertMessage(this.dialog, "Please Enter Time To Escalation between 1 and 72");
              this.updateNotifyflag = true;
              return false;
            }
          }
          else if(this.AlarmSubType_Name != "Low Batteries" && this.AlarmSubType_Name != "Lost Communication")
          {
            if(TimetoEscalatevalue < 1 || TimetoEscalatevalue > 60  && this.checkEscalate == true && this.checkRepeatLevel == false)
            {
              generateAlertMessage(this.dialog, "Please Enter Time To Escalation between 1 and 60");
              this.updateNotifyflag = true;
              return false;
            }
          }
          */ 
            
           let e_notification: UpdateNotification = {
            siteId: this.SiteId,
            authKey: localStorage.getItem("Authkey"),
            alertId: parseInt(this.AlertId),                        
            escalation: this.Escalationlevel,
            timeToEscalate : TimetoEscalatevalue,
            notify : e_notificationFormValue.notify,
            notifyList : e_notificationFormValue.NotifyList.toString(),
            eventName: this.eventName,
            campusId : this.CampusId,           
            campusName: this.campusName,            
            buildingId: this.BuildingId,
            floorId: this.FloorId,
            subzoneId: this.SubZoneId,
            needEscalate: Escalatevalue,
            needRepeat: RepeatLevelvalue,
            repeatCycle: RepeatCyclevalue,
            repeatNumber: RepeatNumbervalue,
            eventType : this.AlarmId,
            subtypeId: this.AlarmSubTypeId,
          }                  
          
            this.notificationService.updateNotification(e_notification).pipe(takeUntil(this._onDestroy))
            .subscribe((apiresponse : NotificationForCreationResponse[])=>{
              if (apiresponse["apiReturn"]!=null && apiresponse["apiReturn"]!=undefined)
              { 
                if(apiresponse["apiReturn"].toString() == "Success")
                { 	
                  this.apiService.reloadNotification(); 
                  generateAlertMessage(this.dialog, 'Escalation data edited successfully.')                  
                }
                else if(apiresponse["apiReturn"].toString() == "Fail")
                {                  
                  this.updateNotifyflag = true;
                  generateAlertMessage(this.dialog, 'Escalation data edited failed.')                   
                }
                else if(apiresponse["apiReturn"] == "Invalid Auth Key")
                {     
                    this.thisDialogRef.close('close');             
                    AuthFailedMessage(this.dialog,this.router);  
                    return;       
                } 
                else
                {
                  this.updateNotifyflag = true;
                  generateAlertMessage(this.dialog, 'Escalation data edited failed.') 
                }
              }
              else
              {                
                this.updateNotifyflag = true;
                generateAlertMessage(this.dialog, 'Escalation data edited failed.')               
              }
              this.thisDialogRef.close('Confirm');
            });
        
            
        }
        catch (err) {
          throw new Error('edit-notification.component.ts' + ' - onEditNotifyClicked() - ' + err.message);
        }
           	
     }

toggleRepeatLevel(event)
{
  if(event.checked == true)
  {
    this.checkRepeatLevel = true;
    this.notificationeditCreationForm.get('RepeatLevelNumber').enable();
    this.notificationeditCreationForm.get('RepeatLevelCycle').enable();
    
    if(this.checkEscalate == true)
      this.notificationeditCreationForm.get('TimeToEscalate').disable(); 
  }
  else if(event.checked == false)
  {
    this.checkRepeatLevel = false;
    this.RepeatCyclevalue = "";
    this.RepeatNumbervalue = "";
    this.notificationeditCreationForm.get('RepeatLevelNumber').disable();
    this.notificationeditCreationForm.get('RepeatLevelCycle').disable();
    
    if(this.checkEscalate == true)
      this.notificationeditCreationForm.get('TimeToEscalate').enable(); 
  }
}

toggleEscalate(event)
{
  if(event.checked == true)
  {
    this.checkEscalate = true;
    this.notificationeditCreationForm.get('TimeToEscalate').enable();  
    
    if(this.checkRepeatLevel == true)
    {      
      this.notificationeditCreationForm.get('TimeToEscalate').disable(); 
      this.calculateTimeEscalate();
    }
  }
  else if(event.checked == false)
  {
    this.checkEscalate = false;
    this.TimeEscalatevalue = "";
    this.notificationeditCreationForm.get('TimeToEscalate').disable();    
  }
}

mouseleaveRepeatCycle()
{
  if(this.checkEscalate == true && this.checkRepeatLevel == true)
    this.calculateTimeEscalate();
}

calculateTimeEscalate()
{
  var repeatNumbervalue = this.notificationeditCreationForm.value.RepeatLevelNumber;
  var repeatCyclevalue = this.notificationeditCreationForm.value.RepeatLevelCycle;
  if(repeatNumbervalue != "" && repeatCyclevalue != "" && /^[0-9]*$/.test(repeatCyclevalue) && /^[0-9]*$/.test(repeatNumbervalue))
    this.TimeEscalatevalue = (repeatNumbervalue * repeatCyclevalue) + parseInt(repeatCyclevalue); 
}
     
ngOnDestroy() {
  this._onDestroy.next();
  this._onDestroy.complete();
}

}

